import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { Button } from './Buttons'
import { Typography } from './Typography'

import { ReloadPageButtonMessage } from '@messages'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 30px 20px;
  width: 100%;
  height: 100%;
`

export function PageLoadingErrorView() {
  function handleReloadWindow() {
    window.location.reload()
  }

  return (
    <Wrapper className="page-loading-container">
      <Typography size="400-md" color="error" align="center">
        <FormattedMessage
          id="pages.asyncLoad.error"
          defaultMessage="Az oldal betöltése sikertelen, kérjük próbálja meg újratölteni."
        />
      </Typography>
      <Button variant="secondaryContained" size="small" onClick={handleReloadWindow}>
        {ReloadPageButtonMessage}
      </Button>
    </Wrapper>
  )
}
